<template lang="pug">
    .scenes
        dragger(@draggerDone="draggerDone()", v-if="showDragger")
        scene-title(:title="$route.name", @sceneTitleDone="sceneTitleDone()", v-if="showSceneTitle")
        scene-text(:content="text", @sceneTextDone="sceneTextDone()" v-if="showSceneText")
            
</template>
<script>
import sceneText from '@/components/sceneText.vue';
import sceneTitle from '@/components/sceneTitle.vue';
import dragger from '@/components/dragger.vue';
export default {
    data() {
        return {
            text: this.$route.meta.text,
            showSceneTitle: true,
            showSceneText: false,
            showDragger: false
        }
    },
    methods: {
        sceneTitleDone() {
            console.log('sceneTitleDone()')
            this.showSceneTitle = false,
            this.showSceneText = true,
            this.showDragger = false
        },
        sceneTextDone() {
            if (this.$route.name !== 'Moving') {
                console.log('sceneTextDone()')
                this.showSceneTitle = false,
                this.showSceneText = false,
                this.showDragger = true
            } else {
                this.goToNextRoute()
            }
        },
        draggerDone() {
            console.log('draggerDone()')
            this.showSceneTitle = false,
            this.showSceneText = false,
            this.showDragger = false
            this.goToNextRoute()
        },
        goToNextRoute() {
            console.log('go to next route')
            var BreakException = {}

            try {
                Object.entries(this.$router.options.routes).forEach(
                    ([key, value]) => {
                        
                        let q = 0

                        if (value.name === this.$route.name) {
                            let p = key
                            p++
                            let nextRoute = this.$router.options.routes[p]
                            console.log(`going to ${nextRoute.name}`)
                            this.$router.push({ name: nextRoute.name})

                            throw BreakException
                        }
                    }
                )
            } catch (e) {
                if (e !== BreakException) throw e;
            }
        }
    },
    components: {
        sceneText,
        sceneTitle,
        dragger
    }
}
</script>
<style lang="scss">
.scenes {
    width: 100vw;
    height: 100vh;
    display: flex;
    position: absolute;
    top: 0; left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/scene.vue